module.exports = __webpack_public_path__ + "img/ae.43e2ab1b.svg";